
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import BannerSimple from "~/cms/blocks/components/BannerSimpleBlock/BannerSimple.vue";
export default BaseCmsBlock.extend({
  name: 'BannerSimpleBlock',

  components: {
    BannerSimple,
  },

  data() {
    return {
      windowWidth: null,
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleWindowSize());
    this.handleWindowSize();
  },
  computed: {
    blockTitle: function () {
      return this.values?.title || '';
    },
    mobileBackground: function () {
      return this.values?.mobile_background && this.values.mobile_background !== 0 ? this.values?.mobile_background : this.values?.background;
    },
    bannerImage: function () {
      return this.isMobile ? this.mobileBackground : this.values?.background;
    },
    isMobile: function () {
      if (!process.client) {
        return false
      }
      return this.windowWidth < 1000;
    },
  },
  methods: {
    handleWindowSize: function () {
      this.windowWidth = window.innerWidth;
    },
  },
});
